import React, { Component } from "react";
import styles from "./Map.scss";
import CMSComponent from "../../../components/CMSComponent";
import SignUpButton from "../../../components/global/SignUpButton";

class Map extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h2 className={styles.heading}>
            Changing the world one ticket at a time
          </h2>
          <p className={styles.text}>
            Humanitix is the not-for-profit ticketing platform that gives events
            impact. We make event management a delight, and direct 100% of
            profits from booking fees toward education projects.
          </p>
          <div className={styles.button}>
            <SignUpButton size="large" ariaHidden>
              Join our story
            </SignUpButton>
          </div>
        </div>
      </div>
    );
  }
}

export default CMSComponent(null, Map, 500);
